import React from "react";
import { connect } from "react-redux";
import { setName } from "../actions/";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import SVG from "react-inlinesvg";

import LoadingScreen from "./LoadingScreen";
import "../css/MainPage.scss";

class MainPage extends React.Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    state = {
        contentLoaded: false,
        mockupAnimation: false,
        hideMockup: false,
        pageAnimation: false,
        navigationSarted: false,
        country: "US"
    };

    componentDidMount() {
        window.addEventListener("load", () => {
            this.setState({
                contentLoaded: true
            });

            try {
                const getCountry = this.props.cookies.get("_dy_df_geo").split(".")[0];
                if (getCountry === "United Kingdom") {
                    this.setState({
                        country: "UK"
                    });
                }
            } catch (error) { }

            setTimeout(() => {
                this.setState({
                    mockupAnimation: true
                });
            }, 250);
        });

        if (this.getParameterByName("firstname")) {
            const firstName = this.getParameterByName("firstname");
            this.props.setName(firstName);

            // Hide ?firstname= from url after state has been set
            const historyUrl =
                window.top.location.origin + window.top.location.pathname;
            window.history.pushState(
                null,
                "Build Your Customer Loyalty Program | Yotpo",
                historyUrl
            );
        }
    }

    getParameterByName = (name, url) => {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };

    handleOnClick = () => {
        document.querySelector(".site-header").classList = "site-header animate";
        document.querySelector(".app-wrapper").classList = "app-wrapper animate";

        this.setState({
            hideMockup: true
        });

        setTimeout(() => {
            this.props.history.push("/industry");
        }, 1500);
    };

    animationEndHandler = e => {
        this.setState({
            pageAnimation: true
        });
    };

    render() {
        if (!this.state.contentLoaded) {
            return <LoadingScreen />;
        }
        if (this.state.contentLoaded) {
            return (
                <div
                    className={
                        "main-page " + (this.state.pageAnimation ? "animate" : "")
                    }>
                    <div className="text-half">
                        <div
                            className={
                                "text-container " +
                                (this.state.mockupAnimation ? "animate" : "")
                            }>
                            <h1>Create your own Loyalty & Referrals program</h1>
                            <div className="description">
                               Make happy customers your competitive advantage with on-brand Loyalty & Referrals programs
							</div>
                            <div className="button-wrapper">
                                <button
                                    onClick={ this.handleOnClick }
                                    disabled={ this.state.hideMockup ? "true" : "" }>
                                    Get started{ " " }
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12">
                                        <g fill="none">
                                            <g fill="#FFF">
                                                <polygon
                                                    transform="translate(-530 -577)translate(359 250)translate(0 304)translate(31 17)translate(146 12)scale(-1 1)translate(-146 -12)"
                                                    points="152 11.3 142.9 11.3 147.1 7.1 146 6 140 12 146 18 147.1 16.9 142.9 12.8 152 12.8"
                                                />
                                            </g>
                                        </g>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="purple-half">
                        <div
                            className={
                                "report-mockup " +
                                (this.state.hideMockup ? "hide-mockup " : "") +
                                (this.state.mockupAnimation ? "animate" : "")
                            }
                            onAnimationEnd={ this.animationEndHandler }>
                            <div
                                className={
                                    "report-page-base " +
                                    (this.state.mockupAnimation ? "animate" : "")
                                }>
                                <div className="element">
                                    <img
                                        alt="alt"
                                        src="./images/report-page-base.png"
                                        srcSet="./images/report-page-base.png 1x ,./images/report-page-base@2x.png 2x"
                                    />
                                </div>
                            </div>

                            <div
                                className={
                                    "report-banner " +
                                    (this.state.mockupAnimation ? "animate" : "")
                                }>
                                <div className="element">
                                    <img
                                        alt="alt"
                                        src={ "./images/report-banner-" + this.state.country + ".png" }
                                        srcSet={ "./images/report-banner-" + this.state.country + ".png 1x, ./images/report-banner-" + this.state.country + "@2x.png 2x" }
                                    />
                                </div>
                                <div className="shadow">
                                    <img alt="alt" src="./images/report-banner-shadow.svg" />
                                </div>
                            </div>
                            <div
                                className={
                                    "squares " + (this.state.mockupAnimation ? "animate" : "")
                                }>
                                <div className="report-square square-1">
                                    <div className="element">
                                        <img
                                            alt="alt"
                                            src={ "./images/square-10-OFF-" + this.state.country + ".png" }
                                            srcSet={ "./images/square-10-OFF-" + this.state.country + ".png 1x, ./images/square-10-OFF-" + this.state.country + "@2x.png 2x" }
                                        />
                                    </div>
                                    <div className="shadow">
                                        <img alt="alt" src="./images/report-square-shadow.svg" />
                                    </div>
                                </div>
                                <div className="report-square square-2">
                                    <div className="element">
                                        <img
                                            alt="alt"
                                            src={ "./images/square-20-OFF-" + this.state.country + ".png" }
                                            srcSet={ "./images/square-20-OFF-" + this.state.country + ".png 1x, ./images/square-20-OFF-" + this.state.country + "@2x.png 2x" }
                                        />
                                    </div>
                                    <div className="shadow">
                                        <img alt="alt" src="./images/report-square-shadow.svg" />
                                    </div>
                                </div>
                                <div className="report-square square-3">
                                    <div className="element">
                                        <img
                                            alt="alt"
                                            src={ "./images/square-30-OFF-" + this.state.country + ".png" }
                                            srcSet={ "./images/square-30-OFF-" + this.state.country + ".png 1x, ./images/square-30-OFF-" + this.state.country + "@2x.png 2x" }
                                        />
                                    </div>
                                    <div className="shadow">
                                        <img alt="alt" src="./images/report-square-shadow.svg" />
                                    </div>
                                </div>
                            </div>
                            <div
                                className={
                                    "purple-squares " +
                                    (this.state.mockupAnimation ? "animate" : "")
                                }>
                                <div className="purple-square square-1">
                                    <div className="element">
                                        <img
                                            alt="alt"
                                            src="./images/purple-square-1.png"
                                            srcSet="./images/purple-square-1.png 1x ,./images/purple-square-1@2x.png 2x"
                                        />
                                    </div>
                                    <div className="shadow">
                                        <img alt="alt" src="./images/report-square-2-shadow.svg" />
                                    </div>
                                </div>
                                <div className="purple-square square-2">
                                    <div className="element">
                                        <img
                                            alt="alt"
                                            src="./images/purple-square-2.png"
                                            srcSet="./images/purple-square-2.png 1x ,./images/purple-square-2@2x.png 2x"
                                        />
                                    </div>
                                    <div className="shadow">
                                        <img alt="alt" src="./images/report-square-2-shadow.svg" />
                                    </div>
                                </div>
                                <div className="purple-square square-3">
                                    <div className="element">
                                        <img
                                            alt="alt"
                                            src="./images/purple-square-3.png"
                                            srcSet="./images/purple-square-3.png 1x ,./images/purple-square-3@2x.png 2x"
                                        />
                                    </div>
                                    <div className="shadow">
                                        <img alt="alt" src="./images/report-square-2-shadow.svg" />
                                    </div>
                                </div>
                                <div className="purple-square square-row">
                                    <div className="element">
                                        <img
                                            alt="alt"
                                            src="./images/purple-squares-row.png"
                                            srcSet="./images/purple-squares-row.png 1x ,./images/purple-squares-row@2x.png 2x"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                className={
                                    "graph-element " +
                                    (this.state.mockupAnimation ? "animate " : "") +
                                    (this.state.hideMockup ? "hide-mockup" : "")
                                }>
                                <SVG className="line" src="./images/graph-element-line.svg" />
                                <img
                                    className="full"
                                    alt="alt"
                                    src="./images/graph-element-full.png"
                                    srcSet="./images/graph-element-full.png 1x ,./images/graph-element-full@2x.png 2x"
                                />
                            </div>
                            <div
                                className={
                                    "triangle-element " +
                                    (this.state.mockupAnimation ? "animate " : "") +
                                    (this.state.hideMockup ? "hide-mockup" : "")
                                }>
                                <img
                                    className="line"
                                    alt="alt"
                                    src="./images/triangle-line.png"
                                    srcSet="./images/triangle-line.png 1x ,./images/triangle-line@2x.png 2x"
                                />
                                <img
                                    className="full"
                                    alt="alt"
                                    src="./images/triangle-full.png"
                                    srcSet="./images/triangle-full.png 1x ,./images/triangle-full@2x.png 2x"
                                />
                            </div>
                            <div
                                className={
                                    "report-background-shapes " +
                                    (this.state.hideMockup ? "hide-mockup" : "")
                                }>
                                <img alt="alt" src="./images/report-background-shapes.svg" />
                            </div>
                        </div>
                        <div
                            className={
                                "report-page-base-shadow " +
                                (this.state.mockupAnimation ? "animate " : "") +
                                (this.state.hideMockup ? "hide-mockup" : "")
                            }>
                            <div className="shadow">
                                <img src="./images/report-page-base-shadow.svg" alt="shadow" />
                            </div>
                        </div>
                        <div
                            className={
                                "report-logo " +
                                (this.state.mockupAnimation ? "animate " : "") +
                                (this.state.hideMockup ? "hide-mockup" : "")
                            }>
                            <img alt="alt" src="./images/loyalty-gen-logo.svg" />
                        </div>
                    </div>
                    <div
                        className={
                            "report-ipad-mockup " +
                            (this.state.mockupAnimation ? "animate " : "") +
                            (this.state.hideMockup ? "hide-mockup" : "")
                        }>
                        <img
                            className="full"
                            alt="alt"
                            src="./images/report-ipad-mockup.jpg"
                            srcSet="./images/report-ipad-mockup.jpg 1x ,./images/report-ipad-mockup@2x.jpg 2x"
                        />
                    </div>
                    <div
                        className={
                            "report-mobile-mockup " +
                            (this.state.mockupAnimation ? "animate " : "") +
                            (this.state.hideMockup ? "hide-mockup" : "")
                        }>
                        <img
                            className="full"
                            alt="alt"
                            src="./images/report-mobile-mockup.png"
                            srcSet="./images/report-mobile-mockup.png 1x ,./images/report-mobile-mockup@2x.png 2x"
                        />
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = state => {
    return {
        name: state.name
    };
};

export default withCookies(
    connect(
        mapStateToProps,
        { setName }
    )(MainPage)
);
